import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateValidationService {
  isInvalidNetDate(dateString: string): boolean {
    if (!dateString || typeof dateString !== 'string') {
      return false;
    }

    const invalidDates = ['0001-01-01', '1900-01-01', '0001-01-01T00:00:00', '1900-01-01T00:00:00'];

    for (const invalidDate of invalidDates) {
      if (dateString.startsWith(invalidDate)) {
        return true;
      }
    }

    const yearMatch = dateString.match(/^(\d{4})-/);
    if (yearMatch) {
      const year = parseInt(yearMatch[1], 10);
      if (year < 1910) {
        return true;
      }
    }

    return false;
  }

  shouldExcludeDate(dateValue: string | Date | null | undefined): boolean {
    if (!dateValue) {
      return true;
    }

    if (typeof dateValue === 'string') {
      return this.isInvalidNetDate(dateValue);
    }

    if (dateValue instanceof Date) {
      const year = dateValue.getFullYear();
      return year < 1910;
    }

    return true;
  }
}
